module.exports = __webpack_public_path__ + "img/eretz-pulsing.ae3b246b.gif";